/**
 * Event class for QueryClient lifecycle events.
 *
 * This class represents events that track the various stages of query execution
 * within the QueryClient, providing type-safe event data and transaction tracking.
 *
 * @template TData - The type of data associated with this event
 */
export class QueryClientEvent {
    type;
    transaction;
    data;
    /**
     * Creates a new QueryClient event.
     *
     * @param type - The specific event type identifier
     * @param transaction - Unique transaction identifier for the query operation
     * @param data - Optional event-specific data payload
     */
    constructor(type, transaction, data) {
        this.type = type;
        this.transaction = transaction;
        this.data = data;
    }
}
//# sourceMappingURL=QueryClientEvent.js.map